module.exports = __webpack_public_path__ + "static/bee-hive-c06cb2e6c6bb8376b441f197a47f4595.jpg";